/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Execute_Requires_AssigneeInputs */

const en_task_execute_requires_assignee = /** @type {(inputs: Task_Execute_Requires_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assign someone to this task before completing it.`)
};

const pt_br2_task_execute_requires_assignee = /** @type {(inputs: Task_Execute_Requires_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Defina um responsável antes de concluir esta atividade.`)
};

/**
* | output |
* | --- |
* | "Assign someone to this task before completing it." |
*
* @param {Task_Execute_Requires_AssigneeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_execute_requires_assignee = /** @type {((inputs?: Task_Execute_Requires_AssigneeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Execute_Requires_AssigneeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_execute_requires_assignee(inputs)
	return pt_br2_task_execute_requires_assignee(inputs)
});